import React, { forwardRef } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const FileDropDown = forwardRef(({ onDelete, onEdit, userId, isOpen, onToggle }, ref) => {
  const options = ['Edit', 'Delete'];
  
  let availableOptions;

  if (!JSON.parse(localStorage.getItem("adminData")).superAdmin) {
    availableOptions = options.filter(option => JSON.parse(localStorage.getItem("adminData"))?.role?.permissions?.includes(`Can ${option.toLowerCase()} users`));
  } else {
    availableOptions = options;
  }

  const handleToggle = () => {
    onToggle();
  };

  const handleOptionClick = (option) => {
    if (option === 'Delete') {
      onDelete(userId);
    } else if (option === 'Edit') {
      onEdit(userId);
    }
  };

  return (
    <div className="dropdown" ref={ref}>
      <button onClick={handleToggle} className="dropdown-toggle">
        <span> Action </span>
        <KeyboardArrowDownIcon />
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {availableOptions.map((option) => (
            <li
              key={option}
              onClick={() => handleOptionClick(option)}
              className="dropdown-item"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

export default FileDropDown;
